import { Component, Inject } from "@angular/core";
import { NbDialogRef  } from '@nebular/theme';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomCriteriaService } from './customCriteriaService';

@Component({
  selector: 'app-ventana-modal',
  templateUrl: './ventanamodal.component.html',
  styleUrls: ['./ventanamodal.component.scss']
})
export class VentanaModalComponent {
  vTipo: string;
  currentValueCV: string;
  resultado: string;

  constructor(public dialogRef: MatDialogRef<VentanaModalComponent>,
    public modalService: CustomCriteriaService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.resultado = data.resultado;
    }

  cerrarVentanaModal() {
    this.dialogRef.close()
  }

  aceptarVentanaModal() {
    this.data.resultado = this.resultado
    if (this.modalService.expresionValida == false){
      this.dialogRef.close()
    }else{
      this.dialogRef.close(this.data)
    }
  }

}

